var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "201px",
    height: "201px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 28,
    strokeWidth: 3,
    stroke: "#ffffff",
    strokeDasharray: "43.982297150257104 43.982297150257104",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1.639344262295082s",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loader-white.8beec21fe2e63843c785c6c9095c960e.svg";
export { ForwardRef as ReactComponent };